import Vue from "vue";
import LoginWidget from "./FavoritePageButtonWidget.vue";

Vue.config.productionTip = false;

let element = document.querySelectorAll('widget-favorite-page-button');
if (element.length) {
    element.forEach(el => {
        new Vue({
            el: el,
            render(h) {
                let labels = this.$el.attributes.getNamedItem('labels');

                return h(LoginWidget, {
                    props: {
                        labelsJson: labels ? labels.value : null
                    }
                })
            }
        });
    });
}
